import deployment56 from "./56.json" with { type: "json" };
import deployment97 from "./97.json" with { type: "json" };
import deployment31337 from "./31337.json" with { type: "json" };
import { verifyDeploymentManifest } from "../deployment.js";
/** Generated from checksum-verified chain manifests by contracts/scripts/deploy.ts. */
export const GENERATED_DEPLOYMENTS = [
    verifyDeploymentManifest(deployment56),
    verifyDeploymentManifest(deployment97),
    verifyDeploymentManifest(deployment31337),
];
//# sourceMappingURL=index.js.map